import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import whiteCheckmarkImage from 'images/white-check.svg'
import classnames from 'classnames'
import { removeOtherType } from 'utils'
import { LanguageIcon } from 'components/icons/basic'

const propTypes = {
  artsLanguagesResources: PropTypes.arrayOf(Types.requestedInterest).isRequired,
  allLanguages: PropTypes.arrayOf(Types.language).isRequired,
  className: PropTypes.string,
}

const defaultProps = {
  className: '',
}

function LanguagesTabContent({
  artsLanguagesResources,
  className,
  allLanguages,
}) {
  const allSpecificLanguages = removeOtherType(allLanguages)
  const requestedLanguageNames = useMemo(
    () => artsLanguagesResources.map((resource) => resource.name),
    [artsLanguagesResources]
  )

  return (
    <div className={classnames('colored-block card-grid', className)}>
      {allSpecificLanguages.map(({ id, displayName, name, definition }) => (
        <div
          key={id}
          className={classnames('stat-card', 'card', {
            'none-selected': !requestedLanguageNames.includes(name),
          })}
        >
          <div className="stat-inner-with-image">
            <div className="image-block">
              <LanguageIcon />
              <span>
                <img src={whiteCheckmarkImage} alt="Checkmark" />
              </span>
            </div>
            <div className="stack-text">
              <p>{displayName}</p>
              {definition && (
                <span className="small-definition">{definition}</span>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

LanguagesTabContent.propTypes = propTypes
LanguagesTabContent.defaultProps = defaultProps

export default LanguagesTabContent
